import { useFetchMemosApi, usePostMemoApi, usePutMemoApi } from 'api/memo'
import { Flex } from 'components/shared/flex'
import { InputField } from 'components/shared/input'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useEffect, useRef } from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { MemoForm, MemoSearchForm } from 'entities/memo'
import { MemoViewModel } from 'view_models/memo_view_model'
import { BiSend } from 'react-icons/bi'

type MemoFormViewProps = {
    onComplete?: () => void
    memoSearchForm?: MemoSearchForm
    memoForm: MemoForm
}

export const MemoFormView = (props: MemoFormViewProps) => {
    const globalState = useContext(GlobalStateContext)
    const editForm = useForm<MemoForm>({})
    const editApi = usePutMemoApi()
    const newForm = useForm<MemoForm>(props.memoForm)
    const newApi = usePostMemoApi()
    const searchForm = useForm<MemoSearchForm>(props.memoSearchForm || props.memoForm)
    const memosApi = useFetchMemosApi(searchForm)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        memosApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        if (memosApi.isSuccess()) {
            if (ref && ref.current) {
                ref.current.scrollTo({ top: 1000000 })
            }
        }
    }, [memosApi.loading])

    useEffectSkipFirst(() => {
        newForm.set(props.memoForm)
    }, [props.memoForm])

    useEffectSkipFirst(() => {
        globalState.setLoading(newApi.loading)
        if (newApi.isSuccess()) {
            newForm.set(props.memoForm)
        }
    }, [newApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(editApi.loading)
        if (editApi.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
            memosApi.execute()
        }
    }, [editApi.loading])

    useEffectSkipFirst(() => {
        globalState.setLoading(newApi.loading)
        if (newApi.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
            memosApi.execute()
        }
    }, [newApi.loading])

    return (
        <div style={{ margin: 10 }}>
            <div>メモ</div>
            <div style={{ maxHeight: 200, overflowY: 'scroll', marginTop: 10 }} ref={ref}>
                {memosApi.response.results.map((memo) => {
                    const vm = new MemoViewModel(memo)
                    return (
                        <div key={'memo-' + memo.id} style={{ padding: 10 }}>
                            <Flex style={{ fontSize: 11 }}>
                                <div>{vm.createdAtText()}</div>
                                <div>{memo.user?.fullName}</div>
                            </Flex>
                            {memo.sysMessage ? (
                                <Alert variant="info">
                                    {memo.body?.split('\n').map((line, index) => {
                                        return <div key={index}>{line}</div>
                                    })}
                                </Alert>
                            ) : (
                                <div>
                                    {memo.body?.split('\n').map((line, index) => {
                                        return <div key={index}>{line}</div>
                                    })}
                                </div>
                            )}

                            <div style={{ height: 1, width: '100%', backgroundColor: '#ddd', marginTop: 10 }}></div>
                        </div>
                    )
                })}
            </div>
            <div style={{ marginTop: 20 }}>
                <InputField form={newForm} attr={'body'} required apiError={newApi.apiError || editApi.apiError} as="textarea" placeholder="メモを入力" />
                <Flex justifyContent="flex-end">
                    <Button
                        size="sm"
                        onClick={() => {
                            newApi.execute(newForm)
                        }}
                    >
                        <BiSend />
                    </Button>
                </Flex>
            </div>
        </div>
    )
}
type NewEditMemoFormProps = MemoFormViewProps & {
    show: boolean
    onClose: () => void
}

export const NewEditMemoForm = (props: NewEditMemoFormProps): JSX.Element => {
    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <MemoFormView {...props} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
